<template>
  <v-navigation-drawer
    v-model="local_drawer"
    app
    clipped
  >
    <v-list dense>
      <template
        class="menu-request"
        v-if="isRequest"
      >
        <v-item-group>
          <v-list-item>
            <v-list-item-title>
              {{ menuRequest.text }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-for="child in menuRequest.children"
            link
            :key="child.name"
            @click="goTo(child.link)"
          >
            <v-list-item-action>
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ child.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-item-group>
        <v-divider
          dark
          class="my-4"
        ></v-divider>
      </template>
      <template
        class="menu-supporter"
        v-if="isSupporter"
      >
        <v-item-group>
          <v-list-item>
            <v-list-item-title>
              {{ menuSupporter.text }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-for="child in menuSupporter.children"
            link
            :key="child.name"
            @click="goTo(child.link)"
          >
            <v-list-item-action>
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ child.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-item-group>
        <v-divider
          dark
          class="my-4"
        ></v-divider>
      </template>
      <template
        class="menu-banner"
        v-if="isBanner"
      >
        <v-item-group>
          <v-list-item>
            <v-list-item-title>
              {{ menuBanner.text }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-for="child in menuBanner.children"
            link
            :key="child.name"
            @click="goTo(child.link)"
          >
            <v-list-item-action>
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ child.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-item-group>
        <v-divider
          dark
          class="my-4"
        ></v-divider>
      </template>
      <template
        class="menu-user"
        v-if="isUser"
      >
        <v-item-group>
          <v-list-item>
            <v-list-item-title>
              {{ menuUser.text }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-for="child in menuUser.children"
            link
            :key="child.name"
            @click="goTo(child.link)"
          >
            <v-list-item-action>
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ child.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-item-group>
        <v-divider
          dark
          class="my-4"
        ></v-divider>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  import { getStorage } from './../../_helpers'
  export default {
    name: 'AppDrawer',
    props: ['drawer'],
    data: () => ({
      local_drawer: null,
      menuRequest: {
        text: 'Monitor Agency',
        children: [
          { icon: 'mdi-account-box-multiple', name: 'request-statistics', text: 'Request Statistics', link: 'request-statistics'},
          { icon: 'mdi-account-box-multiple', name: 'request-helper-maid-list', text: 'Request Maid List', link: 'request-helper-maid-list'},
          { icon: 'mdi-account-box-multiple', name: 'request-helper-driver-list', text: 'Request Driver List', link: 'request-helper-driver-list'},
          { icon: 'mdi-account-box-multiple', name: 'request-helper-status-list', text: 'Request Status', link: 'request-helper-status-list' },
        ]
      },
      menuSupporter: {
        text: 'Supporters',
        children: [
          { icon: 'mdi-account-box-multiple', name: 'supporter-list', text: 'Supporter', link: 'supporter-list' },
        ]
      },
      menuBanner: {
        text: 'Banner',
        children: [
          { icon: 'mdi-account-box-multiple', name: 'banner-list', text: 'Banner List', link: 'banner-list' },
        ]
      },
      menuUser: {
        text: 'Users',
        children: [
          { icon: 'mdi-account-box-multiple', name: 'user-list', text: 'User', link: 'user-list' },
          { icon: 'mdi-account-box-multiple', name: 'role-list', text: 'Role', link: 'role-list' },
        ]
      },
      isRequest: false,
      isSupporter: false,
      isBanner: false,
      isUser: false
    }),
    watch: {
      drawer: {
        handler () {
          this.local_drawer = this.drawer
        }
      },
      local_drawer: {
        handler () {
          this.$emit('toggleDrawer', this.local_drawer)
        }
      }
    },
    mounted () {
      this.local_drawer = this.drawer
      let { permission } = getStorage('_admin')
      this.isRequest = permission.includes('Request') || false
      this.isSupporter = permission.includes('Supporter') || false
      this.isBanner = permission.includes('Banner') || false
      this.isUser = permission.includes('User') || false
    },
    methods: {
      goTo (link) {
        if (link && link != this.$router.currentRoute.name)
          return this.$router.push({ name: link })
      }
    }
  }
</script>
